// extracted by mini-css-extract-plugin
export default {"toggle":"_3TkWU","tooltip":"_1FlGF","badge-icon":"_3y_Rq","badgeIcon":"_3y_Rq"};